define('drops/radioButtonList/radioButtonList',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/required'
], function ($, Drop, Style, Required) {
    'use strict';

    var defaults = {
        data: {
            layout: 'horizontal',
            useBuiltInStyle: true,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function RadioButtonList(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.value = null;

        this.$radiobuttons = $('<span />');

        this.$element
            .addClass('boxToBorderSize')

            // note: we have to wrap the radio buttons in a another div.
            // If not wrapped, using "overflow: 'auto'" will actually
            // cause a scrollbar to appear when the required indicator is enabled
            .append($('<div />')
                .css({
                    whiteSpace: 'pre-wrap',
                    overflow: 'auto',
                    width: '100%',
                    height: '100%'
                })
                .append(this.$radiobuttons));

        Style.renderStyles(this);
    };

    Drop.extend(RadioButtonList, Drop);

    RadioButtonList.typeName = 'RadioButtonList';

    RadioButtonList.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) {
                self.update(data);
            });
        Required.prototype.addRemoveRequiredIndicator(self);
        this.applyPosition();
    };

    RadioButtonList.prototype.update = function (data) {
        this.$radiobuttons.empty();

        if (!data)
            return;

        var self = this;
        $.each(data.Results, function (key, result) {
            var elementId = self.data.id + '_' + result[self.data.keyOutput];

            var $radioButton = $('<input type="radio" />')
                .attr('name', self.data.id)
                .attr('id', elementId)
                .attr('value', result[self.data.keyOutput])
                .on('change', function () {
                    self.data.value = $radioButton.val();
                    self.updateRequiredIndicator();
                    self.triggerEventIfEnabled('selected', self.data.value);
                    self.triggerEventIfEnabled('changed', self.data.value);
                });

            var $indicator = self.data.useBuiltInStyle
                ? $radioButton
                : $('<label class="customCheckState" />')
                    .append($radioButton)
                    .append($('<div class="customCheckState-tick"></div>'));

            var $label = $('<label />')
                .attr('for', elementId)
                .text(result[self.data.labelOutput]);
            var $element = $('<span />')
                .css({
                    display: 'inline-block'
                })
                .append($indicator)
                .append($label);

            if (self.data.layout === 'horizontal') {
                self.$radiobuttons.append($element);
            } else {
                self.$radiobuttons.append($('<div />').append($element));
            }
        });

        this._updateRadioButtonSelection(this.data.value);
    };

    RadioButtonList.prototype.getValue = function () {
        return this.data.value;
    };

    RadioButtonList.prototype.clearValue = function () {
        this._updateRadioButtonSelection(null);
        this.updateRequiredIndicator();
    };

    RadioButtonList.prototype.setValue = function (update) {
        this._updateRadioButtonSelection(update.value);
        this.updateRequiredIndicator();
    };

    RadioButtonList.prototype._updateRadioButtonSelection = function (value) {
        this.data.value = value;

        if (value) {
            this.$radiobuttons
                .children()
                .find('input[value="' + value + '"]')
                .prop('checked', true);
        } else {
            this.$radiobuttons
                .children()
                .find('input[type="radio"]:checked')
                .prop('checked', false);
        }
    };

    return RadioButtonList;
});




